import { useState, useEffect } from "react";
import type { FileItem } from "../../types";
import { cn } from "@/shared/lib/cn";
import { getThumbnailUrl, isPdf } from "../../utils/fileUtils";
import { FileIcon } from "./FileIcon";

interface FilePreviewSectionProps {
  file: FileItem;
  onImageClick?: (file: FileItem) => void;
}

export function FilePreviewSection({
  file,
  onImageClick,
}: FilePreviewSectionProps) {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [file.id]);

  const thumbnailUrl = file.thumbnailLargeUrl || file.thumbnailUrl;
  const fullThumbnailUrl = thumbnailUrl
    ? getThumbnailUrl(thumbnailUrl)
    : undefined;

  const isClickable =
    (file.type === "image" || isPdf(file)) && !!onImageClick;

  const handlePreviewClick = () => {
    if (isClickable) {
      onImageClick!(file);
    }
  };

  return (
    <div
      className={cn(
        "relative flex h-64 items-center justify-center border-b border-grid-200 bg-grid-50 overflow-hidden",
        isClickable && "cursor-pointer"
      )}
      onClick={handlePreviewClick}
    >
      {fullThumbnailUrl && !imageError ? (
        <img
          src={fullThumbnailUrl}
          alt={file.name}
          className="h-full w-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <FileIcon type={file.type} className="h-24 w-24 text-ink-300" />
      )}
    </div>
  );
}

